import { diffAll } from "./all";
import { diffRole } from "./role";
export { diffAll as diff, diffRole };
